import { ButtonProps } from '../../atoms/Button';
import { TextProps } from '../../atoms/Text';

type BackHeaderInternalProps = {
  button?: ButtonProps;
  text?: TextProps;
};

type BackHeaderPropsValues = {
  '': BackHeaderInternalProps;
};

const propValues: BackHeaderPropsValues = {
  '': {
    button: {
      type: 'Icon',
      size: 'M',
      state: 'Default',
      style: 'PrimarySubdued',
    },
    text: {
      type: 'LabelLarge',
      align: 'Left',
      style: 'Medium500',
      colour: 'NeutralHoverSelected',
    },
  },
};

const getProps = (type: string): BackHeaderInternalProps => {
  const values: BackHeaderInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
